import isValidHttpUrl from "./isValidHttpUrl";

// URL fields on the recruiter settings form and their human-readable labels.
const URL_FIELDS = [
  { field: "website", label: "Website URL" },
  { field: "calendar_url", label: "Calendar URL" },
  { field: "linkedin_url", label: "LinkedIn URL" },
  { field: "instagram", label: "Instagram URL" },
];

// Returns a formError-shaped object ({ field: [message] }) for any URL field
// that is non-empty and not a valid http(s) URL. Empty fields are allowed.
export default function validateRecruiterUrls(recruiter) {
  const errors = {};
  URL_FIELDS.forEach(({ field, label }) => {
    const value = recruiter?.[field];
    if (value && value.trim() && !isValidHttpUrl(value.trim())) {
      errors[field] = [
        `Please enter a valid ${label} starting with https:// (e.g. https://example.com)`,
      ];
    }
  });
  return errors;
}
